import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=7370eeac&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=7370eeac&prod&lang=scss&scoped=true"
import style1 from "./OrderDetail.vue?vue&type=style&index=1&id=7370eeac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7370eeac",
  null
  
)

export default component.exports